export default __webpack_public_path__ + "static/freedom-a941ab05adf9e807a430fecbca2bc272.svg";